<template>
  <v-container
    fluid
    grid-list-xl
  >
    <AppPerfil
      :nome="usuario.nome"
      titulo="Perfil"
    >
      <template v-slot:body>
        <v-row>
          <v-col>
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="i in categorias.length"
                :key="i"
                :href="'#' + categorias[i - 1].id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{
                  categorias[i - 1].descricao
                }}</span>
                <v-icon
                  :color="
                    categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                  "
                >
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row class="pa-8 pt-4 pb-4">
          <keep-alive>
            <component
              :is="currentComponent"
              :key="currentComponent"
              :perfil="usuario.perfil"
              @updatePerfil="(value) => updatePerfil(value)"
            />
          </keep-alive>
        </v-row>
      </template>
      <template v-slot:actions>
        <v-row
          dense
          no-gutters
        >
          <v-btn
            v-if="categoriaAnterior"
            class="mr-2"
            color="secondary"
            outlined
            @click="previous()"
          >
            <v-icon class="mr-2">
              keyboard_arrow_left
            </v-icon>
            ANTERIOR
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            @click="next()"
          >
            {{ categoriaPosterior ? "PRÓXIMO" : "FINALIZAR" }}
            <v-icon class="ml-2">
              {{ categoriaPosterior ? "keyboard_arrow_right" : "check" }}
            </v-icon>
          </v-btn>
        </v-row>
      </template>
    </AppPerfil>

    <dialog-agradecimento
      :dialog-visible="dialogs.dialogAgradecimento.visibilidade"
      :toogle-visible="toogleDialogAgradecimento"
      descricao="Agradecemos pela sua colaboração!
            Você ainda poderá alterar as informações cadastradas a qualquer momento."
      url-redirecionamento="/perfil"
    />

    <dialog-termo-responsabilidade
      :dialog-props="dialogs.dialogTermoResponsabilidade"
    />

    <dialog-info :value="aviso" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppPerfil from '@/components/core/AppPerfil';
import DialogAgradecimento from '@/components/DialogAgradecimento';
import DialogTermoResponsabilidade from '@/components/perfil/DialogTermoResponsabilidade';
import DialogInfo from '@/components/DialogInfo';
import Cadastro from './tabs/Cadastro';
import Formacao from './tabs/Formacao';
import AtuacaoProfissional from './tabs/AtuacaoProfissional';
import AtividadesInteresse from './tabs/AtividadesInteresse';
import PreferenciasTrabalho from './tabs/PreferenciasTrabalho';
import MeuPerfil from './tabs/MeuPerfil';

const perfilRepository = RepositoryFactory.get('perfil');

export default {
  name: 'CadastroPerfil',

  components: {
    AppPerfil,
    DialogTermoResponsabilidade,
    DialogInfo,
    DialogAgradecimento,
    Cadastro,
    AtividadesInteresse,
    Formacao,
    AtuacaoProfissional,
    PreferenciasTrabalho,
    MeuPerfil,
  },

  data() {
    return {
      dialogs: {
        dialogTermoResponsabilidade: { visibilidade: false, dialogAceitar: true, dialogVisualizar: false },
        dialogAgradecimento: { visibilidade: false },
      },
      categoria: '',
      categorias: [
        {
          id: 'cadastro',
          descricao: 'Cadastro',
          icone: 'account_circle',
          component: 'Cadastro',
        },
        {
          id: 'formacao',
          descricao: 'Formação',
          icone: 'school',
          component: 'Formacao',
        },
        {
          id: 'atuacao_profissional',
          descricao: 'Atuação Profissional',
          icone: 'handyman',
          component: 'AtuacaoProfissional',
        },
        {
          id: 'atividades_interesse',
          descricao: 'Atividades de Interesse',
          icone: 'favorite',
          component: 'AtividadesInteresse',
        },
        {
          id: 'preferencias_trabalho',
          descricao: 'Preferências de Trabalho',
          icone: 'rule',
          component: 'PreferenciasTrabalho',
        },
        {
          id: 'meu_perfil',
          descricao: 'Meu Perfil',
          icone: 'perm_contact_calendar',
          component: 'MeuPerfil',
        },
      ],
      currentComponent: '',
      btnNext: 'PRÓXIMO',
    };
  },

  computed: {
    ...mapState({
      isTutorialExibido: (state) => state.tutorial.dados.perfil,
      usuario: (state) => state.auth.usuario,
      aviso: (state) => state.app.aviso,
    }),
    categoriaPosterior() {
      let index = this.categorias.findIndex((c) => c.id === this.categoria);
      if (index !== -1 && this.categorias.length - index > 1) {
        index += 1;
        return this.categorias[index].id;
      }
      return null;
    },
    categoriaAnterior() {
      let index = this.categorias.findIndex((c) => c.id === this.categoria);
      if (index !== -1 && index > 0) {
        index -= 1;
        return this.categorias[index].id;
      }
      return null;
    },
  },

  watch: {
    categoria(value) {
      if (value !== '') {
        const categoria = this.categorias.find((c) => c.id === this.categoria);
        this.currentComponent = categoria ? categoria.component : '';
      }

      if (this.currentComponent === 'MeuPerfil') {
        this.$store.dispatch('app/setAviso', {
          texto: 'Certifique-se que as informações declaradas na aba “Meu Perfil” estão corretas',
          visibilidade: true,
        });
      }
    },
    'dialogs.dialogTermoResponsabilidade.visibilidade': function (value) {
      if (!value && this.dialogs.dialogTermoResponsabilidade.dialogAceitar) {
        if (!this.isTutorialExibido) {
          this.$store.dispatch('app/showTutorial', { nome: 'Perfil' });
        }
      }
    },
  },

  mounted() {
    this.dialogs.dialogTermoResponsabilidade.visibilidade = !this.usuario.perfil.aceitouTermoResponsabilidade;
  },

  methods: {
    updatePerfil(perfil) {
      perfilRepository.update(perfil).then((res) => {
        this.usuario.perfil = res.data;
        if (this.usuario.perfil.nomeSocial) {
          this.usuario.nome = this.usuario.perfil.nomeSocial;
        } else {
          this.usuario.nome = this.usuario.nomeCivil;
        }
        this.$store.dispatch('app/success', { response: res, message: 'Perfil atualizado com sucesso!' });
      });
    },
    toogleDialogAgradecimento() {
      this.dialogs.dialogAgradecimento.visibilidade = !this.dialogs.dialogAgradecimento.visibilidade;
    },
    previous() {
      if (this.categoriaAnterior) {
        this.categoria = this.categoriaAnterior;
        window.scrollTo({
          top: 100,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    next() {
      if (this.categoriaPosterior) {
        this.categoria = this.categoriaPosterior;
        window.scrollTo({
          top: 100,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        this.toogleDialogAgradecimento();
      }
    },
  },
};
</script>
